import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { CuestionarioSalud } from '../../models/cuestionario-salud/cuestionario-salud';
import { FiltroCuestionarioSalud } from '../../models/filtro-cuestionario-salud/filtro-cuestionario-salud';

@Injectable({
  providedIn: 'root',
})
export class CuestionarioSaludService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.CUESTIONARIO_SALUD}`;
  constructor(private http: HttpClient) {}

  getCuestionarioSalud(idCuestionario: number): Observable<CuestionarioSalud> {
    const url = `${this.apiUrl}/${idCuestionario}`;
    return this.http.get<CuestionarioSalud>(url);
  }

  getCuestionarioSaludConFiltros(
    filtros: FiltroCuestionarioSalud,
  ): Observable<CuestionarioSalud[]> {
    const url = `${this.apiUrl}/filtros`;
    return this.http.post<CuestionarioSalud[]>(url, filtros);
  }
}
